<svg [ngClass]="{ 'timeline-bullet': !disabled, 'timeline-bullet-disabled': disabled }"
     width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle [attr.stroke-opacity]="opacity" cx="6.5" cy="6.5" r="5.5" fill="white" stroke="currentColor" stroke-width="2"/>
  <circle cx="6.5" cy="6.5" r="2.5" fill="currentColor"/>
</svg>
